import React, { memo, useState, useCallback } from 'react';
import { Collapse, createUseStyles, Icon, Popover, Text, useTheme } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';

import styles from './styles.FiltersSection';
const useStyles = createUseStyles(styles, 'FiltersSection');

const FiltersSection = ({ title, filterNum, children, className, headerClassName, hint }) => {
    const [open, setOpen] = useState(true);
    const classes = useStyles();
    const theme = useTheme();

    const rootClass = classnames(classes.root, className, {
        [classes.expanded]: open,
    });

    const headerClass = classnames(classes.header, headerClassName);

    const toggle = useCallback(() => {
        setOpen(!open);
    }, [open]);

    return (
        <div className={rootClass}>
            <div className={headerClass} onClick={toggle}>
                <Text className={classes.title} type="subtitle">
                    {title}
                    {filterNum && ` (${filterNum})`}
                </Text>
                {hint && (
                    <Popover
                        trigger={['hover']}
                        content={
                            <div className={classes.hintContent}>
                                {hint.title && (
                                    <Text type="subtitle" medium>
                                        {hint.title}
                                    </Text>
                                )}
                                {hint.description && (
                                    <Text
                                        color={theme.colors.textLight.secondary}
                                        className={classes.hintContentDescription}
                                    >
                                        {hint.description}
                                    </Text>
                                )}
                            </div>
                        }
                    >
                        <span className={classes.hint}>
                            <Icon
                                name={hint.icon || 'info'}
                                size={hint.iconSize || 'smallMedium'}
                                color="currentColor"
                            />
                            {hint.new && (
                                <Text
                                    color={theme.colors.actionMajor[500]}
                                    type="caption"
                                    className={classes.new}
                                >
                                    {hint.new}
                                </Text>
                            )}
                        </span>
                    </Popover>
                )}
                <Icon className={classes.icon} name="expandLess" size="large" />
            </div>
            <Collapse isOpen={open}>{children}</Collapse>
        </div>
    );
};

export default memo(FiltersSection);
